import { ControllerFlowAPI, CreateControllerFn } from '@wix/yoshi-flow-editor';
import { getInitialState } from './state/state';
import { createViewModel } from './viewModel/viewModel';
import { uoUWidgetLoadOnLiveSiteSrc187Evid8 } from '@wix/bi-logger-bookings-data/v2';
import { BI_WIDGET_NAME } from '../consts';
import { Service } from '@wix/ambassador-bookings-services-v2-service/types';
import { LoadedAsyncComponentData } from '../types';
import { getServicesIds } from './adapters/getServices';

export const createController: CreateControllerFn = async ({ flowAPI }) => {
  const {
    controllerConfig: { setProps },
    bi,
    environment,
  } = flowAPI;
  // For more info about controller structure,
  // check the docs: https://bo.wix.com/pages/yoshi/docs/editor-flow/structure-api/component/ooi-component#controller

  const pageReady = async () => {
    const state = await getInitialState({ flowAPI });
    const viewModel = createViewModel({ flowAPI, state });
    setProps({ viewModel, fitToContentHeight: true });
    bi?.updateDefaults(
      getPlatformBiLoggerDefaultsConfig(flowAPI, BI_WIDGET_NAME),
    );
    const msid = flowAPI.controllerConfig.platformAPIs.bi?.metaSiteId;
    bi?.report(
      uoUWidgetLoadOnLiveSiteSrc187Evid8({
        widgetName: BI_WIDGET_NAME,
        environment: JSON.stringify(environment),
        servicesIds: JSON.stringify(getServicesIds(state.services)),
        accountMsid: msid,
        siteId: msid,
        msid,
      }),
    );
  };
  return {
    pageReady,
    updateConfig(_$w, data) {
      pageReady();
    },
  };
};

export function getPlatformBiLoggerDefaultsConfig(
  flowAPI: ControllerFlowAPI,
  widgetName: string,
) {
  const {
    biToken = '',
    businessId = '',
    isOwner,
    isOverEditor,
    ownerId,
    uid = '',
  } = prepareConfigParams(flowAPI);

  return {
    widget_name: widgetName,
    businessId,
    biToken,
    is_owner: isOwner,
    is_over_editor: isOverEditor,
    ownerId,
    visitor_id: uid,
    bookingsPlatform: 'new_bookings_server',
  };
}

function prepareConfigParams(flowAPI: ControllerFlowAPI): any {
  const { isEditor, isPreview } = flowAPI.environment;
  const { platformAPIs } = flowAPI.controllerConfig;
  const visitorId = platformAPIs.bi?.visitorId || '';
  const ownerId = platformAPIs.bi?.ownerId || '';
  const memberId = flowAPI.controllerConfig.wixCodeApi.user.currentUser.id;
  const isOwner = ownerId === visitorId || ownerId === memberId;

  return {
    uid: visitorId,
    biToken: platformAPIs.bi?.biToken || '',
    businessId: flowAPI.controllerConfig.appParams.instanceId,
    isOwner,
    ownerId,
    isOverEditor: isEditor || isPreview,
  };
}
